module.exports = __webpack_public_path__ + "img/api_img04.ecf4f84e.png";